var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Hamburger menu"},[React.createElement("path",{"id":"Vector","d":"M4 19H20","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"id":"Vector_2","d":"M4 5H20","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"id":"Vector_3","d":"M4 12H20","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]));
}

Hamburger.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
